import { type FC, useEffect } from "react";
import { useAuthContext } from "senf-shared";
import type { Project } from "senf-shared/types";
import SimpleAuthOptions from "../../../templates/auth/SimpleAuthOptions";

interface SurveyLoginProps {
  formik?: unknown; // kept for backward compatibility, but unused
  setSurveyLoginFormShown: (shown: boolean) => void;
  project: Project;
}

const SurveyLogin: FC<SurveyLoginProps> = ({
  setSurveyLoginFormShown,
  project,
}) => {
  const { user } = useAuthContext();

  // Close the survey login form when user successfully authenticates
  useEffect(() => {
    if (user?.authenticated) {
      setSurveyLoginFormShown(false);
    }
  }, [user?.authenticated, setSurveyLoginFormShown]);

  return (
    <div className="mx-auto flex max-w-md flex-col">
      <SimpleAuthOptions project={project} />
    </div>
  );
};

export default SurveyLogin;
